import { useDispatch } from "react-redux";
import { createNoticePopupState } from "../store/actions/actions";

const useCreateNoticeCancel = () => {
	const dispatch = useDispatch();
	return () => {
		dispatch(
			createNoticePopupState({
				popupOpened: false,
				page: 0,
				pageName: null,
				lastPage: 0,
				title: "",
				start: "",
			})
		);
	};
};

export default useCreateNoticeCancel;
